import cn from "classnames";
import { SCREENER_GROUPS } from "epsm-api-types/models";
import { Button } from "@/components/ui/button";
import { useWidgetView } from "@/context/WidgetViewContext";

export const Groups = ({
	baseId,
	fieldsCounter,
}: {
	baseId: string;
	fieldsCounter?: Record<string, number>;
}) => {
	const {
		INITIAL_GROUP,
		selectedGroup,
		setSelectedGroup,
		isShowDescription,
		setIsShowDescription,
	} = useWidgetView();

	return (
		<div className="min-w-40 w-1/4 border-box rounded-sm">
			<h3 className="py-1 px-1.5 text-accent-foreground italic">Categories</h3>

			<div className="grid gap-0.5 px-0.5 overflow-y-scroll max-h-without-btn">
				{[{ name: INITIAL_GROUP }, SCREENER_GROUPS].flat().map((group) => (
					<Button
						key={group.name}
						className={cn(
							`inline-block text-stone-400 h-max py-0 text-start px-1.5
							text-ellipsis hover:text-gold overflow-hidden whitespace-nowrap`,
							{
								"text-gold": group.name === selectedGroup[baseId],
								"px-0.5":
									fieldsCounter && Object.keys(fieldsCounter).length === 0,
							},
						)}
						variant="filter_column"
						onClick={() => {
							setSelectedGroup({ ...selectedGroup, [baseId]: group.name });
							setIsShowDescription({ ...isShowDescription, [baseId]: false });
						}}
					>
						<div className="flex gap-1">
							{fieldsCounter && <p>{fieldsCounter[group.name]}</p>}
							<p>{group.name}</p>
						</div>
					</Button>
				))}
			</div>
		</div>
	);
};
